/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod';

export const pagedListOfGetMacroProjectSchema = z.object({
  items: z.array(
    z.object({
      id: z.coerce.number().int().optional(),
      name: z.coerce.string().min(1).max(500),
      client: z.object({
        value: z.coerce.number().int(),
        label: z.coerce.string(),
      }),
      isVisible: z.boolean(),
      costCenter: z
        .object({
          value: z.coerce.number().int(),
          label: z.coerce.string(),
        })
        .nullable(),
    }),
  ),
  pageNumber: z.coerce.number().int(),
  totalPages: z.coerce.number().int().optional(),
  pageSize: z.coerce.number().int(),
  currentPageSize: z.coerce.number().int().optional(),
  currentStartIndex: z.coerce.number().int().optional(),
  currentEndIndex: z.coerce.number().int().optional(),
  totalCount: z.coerce.number().int().optional(),
  hasPrevious: z.boolean().optional(),
  hasNext: z.boolean().optional(),
  nextPageNumber: z.coerce.number().int().nullable().nullish(),
});
